<template>
  <div>
    <div>
      <div>
        <div id="chartdiv"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";

export default {
  name: "WorldMap",
  props: ["colorObj"],
  computed: {
    mapColorObj() {
      return this.colorObj;
    },
    editorData() {
      return this.$store.state.editor;
    },
    zoomTo() {
      let careerHistory = this.editorData.careerHistory;
      let educationalQualifications = this.editorData.educationalQualifications;
      let countries = [];

      careerHistory.forEach(ch => {
          if(ch.country) countries.push(ch.country.code);
      });

      educationalQualifications.forEach(eq => {
          if(eq.country) countries.push(eq.country.code);
      });

      return countries;
    }
  },
  watch: {
    mapColorObj(newVal) {
      if (newVal) {
        this.loadChart();
        // this.$forceUpdate();
        return newVal;
      }
    },
  },
  methods: {
    startLoader() {
      this.$vs.loading();
    },
    closeLoader() {
      this.$vs.loading.close();
    },
    loadChart() {
      this.startLoader();

      // Create map instance
      let chart = am4core.create("chartdiv", am4maps.MapChart);
      this.chartObj = chart;

      // Set map definition
      chart.geodata = am4geodata_worldLow;

      // Set projection
      chart.projection = new am4maps.projections.Miller();

      // Create map polygon series
      var polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());

      // Exclude Antartica
      polygonSeries.exclude = ["AQ"];

      // Make map load polygon (like country names) data from GeoJSON
      polygonSeries.useGeodata = true;

      // Configure series
      this.polygonTemplate = polygonSeries.mapPolygons.template;
      this.polygonTemplate.tooltipText = "{name}";
      this.polygonTemplate.fill = am4core.color("#D7DBDD");

      // Create hover state and set alternative fill color
      this.hs = this.polygonTemplate.states.create("hover");
      this.hs.properties.fill = am4core.color("#D7DBDD");

      // Create active state
      this.as = this.polygonTemplate.states.create("active");
      this.as.properties.fill = am4core.color(this.mapColorObj);

      // Pre-zoom to a list of countries
      // var zoomTo = ["IN", "CN", "SE", "ZA", "CH", "JP"];
      let zoomTo = this.zoomTo;
      // // console.log(zoomTo);
      chart.events.on("ready", (ev, currentThis=this) => {
        // Init extrems
        var north, south, west, east;

        // Find extreme coordinates for all pre-zoom countries
        for (var i = 0; i < zoomTo.length; i++) {
          var country = polygonSeries.getPolygonById(zoomTo[i]);
          if (north == undefined || country.north > north) {
            north = country.north;
          }
          if (south == undefined || country.south < south) {
            south = country.south;
          }
          if (west == undefined || country.west < west) {
            west = country.west;
          }
          if (east == undefined || country.east > east) {
            east = country.east;
          }

          country.isActive = true;
        }

        // Pre-zoom
        chart.zoomToRectangle(north, east, south, west, 1, true);

        currentThis.closeLoader();
      });

      chart.chartContainer.wheelable = false;

      let labelSeries = chart.series.push(new am4maps.MapImageSeries());
      let labelTemplate = labelSeries.mapImages.template.createChild(am4core.Label);
      labelTemplate.horizontalCenter = "middle";
      labelTemplate.verticalCenter = "middle";
      labelTemplate.fontSize = 20;
      labelTemplate.nonScaling = true;
      labelTemplate.interactionsEnabled = false;

      polygonSeries.events.on("inited", function () {
        polygonSeries.mapPolygons.each(function (polygon) {
          let label = labelSeries.mapImages.create();
          let state = polygon.dataItem.dataContext.name //id.split("-").pop();
          // // console.log(polygon.dataItem.dataContext);
          if(zoomTo.includes(polygon.dataItem.dataContext.id.split("-").pop())) {
            label.latitude = polygon.visualLatitude;
            label.longitude = polygon.visualLongitude;
            // Removed names temporarily
            // label.children.getIndex(0).text = state;
          }
        });
      });
    },
    async disposeMap() {
      if (this.chartObj) {
        this.chartObj.dispose();
      }
    }
  },
  mounted() {
    this.loadChart();
  },
  destroyed() {
    // this.disposeMap();
  },
};
</script>
<style scoped>
#chartdiv {
  width: 100%;
  height: 400px;
}
</style>